import { render, staticRenderFns } from "./EditModelModal.vue?vue&type=template&id=672627a3&lang=pug&"
import script from "./EditModelModal.vue?vue&type=script&lang=js&"
export * from "./EditModelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports